document.addEventListener('DOMContentLoaded', function (e) {
    const popup = e.target.querySelector('.part-popup')
    let popupIsClose = JSON.parse(sessionStorage.getItem('popup-is-close'))
    if (popup) {
        const popupClose = popup.querySelector(
            '.js-close-popup',
        )
        if (popupClose) {
            if (popupIsClose) {
                popup.style.display = 'none'
            } else {
                setTimeout(() => {
                    popup.classList.add('active')
                }, 1000)
            }
            popupClose.addEventListener('click', function (e) {
                sessionStorage.setItem('popup-is-close', 'true')
                popup.classList.add('closed')
                popup.classList.remove('active')
                popupIsClose = true
            })
        }
    }
})
